var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconKey = function SvgIconKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.833 4C2.63 4 0 6.629 0 9.833c0 3.205 2.629 5.834 5.833 5.834 2.313 0 4.242-1.405 5.227-3.334h2.273v2.5h5v-2.5H20v-5h-8.927C10.143 5.396 8.199 4 5.833 4zm0 1.667c1.9 0 3.41 1.184 3.964 2.773L9.99 9h8.343v1.667h-1.666v2.5H15v-2.5h-4.985l-.207.529C9.175 12.813 7.637 14 5.833 14a4.174 4.174 0 0 1-4.166-4.167 4.174 4.174 0 0 1 4.166-4.166zm0 1.666c-1.37 0-2.5 1.13-2.5 2.5 0 1.371 1.13 2.5 2.5 2.5 1.371 0 2.5-1.129 2.5-2.5 0-1.37-1.129-2.5-2.5-2.5zm0 1.667c.47 0 .834.363.834.833s-.364.834-.834.834A.821.821 0 0 1 5 9.833.82.82 0 0 1 5.833 9z",
    fill: "#525254",
    fillRule: "evenodd"
  })));
};

export default SvgIconKey;